import React, { useEffect, useState } from 'react';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';

import AboutData from './AboutData';
import FaqData from './FaqData';
import PolicyCostData from './PolicyCostData';
import PurchasingProcessData from './PurchasingProcessData';
import ProductCarriers from './ProductCarriers';
import TermLengths from '../../../Lists/CoverageLengths/AmericoCoverageLengths';
import LoanProtectionArticleData from './LoanProtectionArticleData';
import AboutMeForm from '../../../../Quoters/AmericoLoanProtection/steps/AboutMeForm';

export default function LoanProtectionData(props) {
  const [primaryBrandColor, setPrimaryBrandColor] = useState(null);

  const minAge = 20;
  const maxAge = 65;
  const minCoverageAmount = 25000;
  const maxCoverageAmount = 1000000;
  
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  const accountProductTypeSettings = props ? accountObj.accountProducts.find(product => product.productLandingUrl === props.history.location.pathname) : null;
  const accountLandingOverride = accountObj.accountOverrides && accountProductTypeSettings ?
    accountObj.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;

  useEffect(() => {
    if (!accountObj.accountOverrides) {
      setPrimaryBrandColor(accountObj.account.primaryColor);
    } else {
      setPrimaryBrandColor(accountObj.accountOverrides.primaryColor);
    }
  }, []);

  const LoanProtectionForm = (<AboutMeForm
    ageSpecs={{ min: minAge, max: maxAge }}
    onNext={() => {
      props.history.push('/loan-protection/quote-results');
    }}
    brandTheme={primaryBrandColor}
    showHeader={false}
    submitButtonVariant={'landing'}
    isLoanProtection={props ? props.isLoanProtection : true}
    unavailableStates={["NY", "VI"]}
  />);

  const defaultValueProposition = [{
    title: " Loan Protection Life Insurance",
    subtitle: "Protect Your Mortgage or Business Loan",
    subtitleExtended: "LoanMatch Protector is the easiest way to secure a term policy to cover a specific financial obligation."
  }];

  return {
    name: 'Loan Protection Life Insurance',
    subtitle: 'Protect Your Mortgage or Business Loan',
    footerMessage: "Get decreasing term life insurance from start to finish completely online.",
    heroText: accountLandingOverride ? JSON.parse(accountLandingOverride.valueProposition) : defaultValueProposition,
    basicInfoForm: () => {
      return LoanProtectionForm;
    },
    about: AboutData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, TermLengths()),
    purchasingProcess: PurchasingProcessData(),
    policyCost: PolicyCostData(),
    faq: FaqData(),
    termArticle: LoanProtectionArticleData(),
    productCarriers: ProductCarriers,
    isAddDefaultFaq: false,
  };
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/LoanProtection/LoanProtectionData.js